export default () => ({
  ioBB: (document.getElementById('ioBB') as HTMLInputElement)?.value ?? null,
});
